import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ShowcasePage from './ShowcasePage';

/** Fixed Demo booth binding for /showcase2. Primary /showcase stays the Demo5 shortcut. */
export const SHOWCASE2_BOOTH_BINDING = {
  booth_device_id: 'Demo',
  booth_camera_id: 'cam_d34013511695',
  booth_zone_id: 'rae_demo_engineering',
  booth_policy_id: 'pol_zone_intrusion_0505fd36',
  site: 'yyz',
} as const;

export function showcase2Search(current = ''): string {
  const params = new URLSearchParams(current.startsWith('?') ? current.slice(1) : current);
  Object.entries(SHOWCASE2_BOOTH_BINDING).forEach(([key, value]) => {
    params.set(key, value);
  });
  const query = params.toString();
  return query ? `?${query}` : '';
}

export function showcase2BindingApplied(search: string): boolean {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return Object.entries(SHOWCASE2_BOOTH_BINDING).every(([key, value]) => params.get(key) === value);
}

/**
 * Same ShowcasePage as /showcase, with the Demo booth query pinned.
 * Does not replace the primary shortcut and does not copy the Demo5 booth.
 */
export default function ShowcaseBackupRoute() {
  const location = useLocation();
  const nextSearch = showcase2Search(location.search);
  if (!showcase2BindingApplied(location.search)) {
    return <Navigate to={{ pathname: '/showcase2', search: nextSearch }} replace />;
  }
  return <ShowcasePage />;
}
